import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {UsersComponent} from './pages/users.component';
import {CanActivateCustomerService} from '../../core/guards/customer/can-activate-customer.service';

const routes: Routes = [
  {
    path: 'ui-service/users',
    component: UsersComponent,
    canActivate: [CanActivateCustomerService]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule {
}
